import { BaseModel } from "@blue-chip/core";
import Client from "./Client";

export default class GLCode extends BaseModel {
  static plural = "glCodes";
  static get belongsTo() {
    return [Client];
  }
}
